import { readonly, ref } from 'vue'

/**
 * How many API calls are in flight right now — the one thing the logo listens to
 * (BrandMark.vue), so the console visibly works while it waits on mdm-service.
 */
const count = ref(0)

export const inFlight = readonly(count)

/** Counts a call for as long as it runs, whatever way it ends. */
export async function track<T>(call: Promise<T>): Promise<T> {
  count.value++
  try {
    return await call
  } finally {
    count.value--
  }
}
